jQuery.noConflict();

(function($) {


    (function () {
        let params;

        $( document ).ajaxComplete(function( event, xhr, settings ) {
            if (!settings.data) {
                return;
            }

            params = new URLSearchParams(settings.data);
            if (params.get('action') === 'ga_calendar_next_month' || params.get('action') ===  'ga_calendar_prev_month') {
                setCalendarLabels();
            }
        });

    })();

    $('.book-strategy-cta').on('click', function () {
        setCalendarLabels();
    });

    const setCalendarLabels = function() {
        const $customTimeSlot = $('.custom-time-slot');
        $customTimeSlot.each(function (key, val) {
            let $val = $(val),
                data = $val.data('val');
            $(val).html(data);
        });

    };

    $(document).ready(function(){

        var isMobile = false; //initiate as false
        // device detection
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;

        $(".gallery-icon a").fancybox();

        (function () {
            $('.book-strategy-wrapper .btn, .book-strategy-cta').on('click', function (e) {
                e.preventDefault();
                $('#strategy-call-modal').modal();
            })
        })();



        $(document).on('ready gform_post_render', function(event, form_id, current_page){
            console.log('is loaded');
            let $bookingControls = $('#booking-controls'),
                $bookingField = $('.field-booking'),
                $calendar = $('#gappointments_calendar');

            $bookingField.on('click', function (e) {
                if (e.target !== this) {
                    return;
                }

                $bookingField.removeClass('active');
            });

            let $dateInput = null,
                $timeInput = null;

            if ($bookingField && $bookingField.length > 0) {
                $dateInput = $bookingField.find('.appointment_booking_date');
                $timeInput = $bookingField.find('.appointment_booking_time');

                if ($dateInput && $timeInput) {
                    $calendar.on('click', function () {
                        setTimeout(function() {
                            let date = $dateInput.val(),
                                time = $timeInput.val();

                            sessionStorage.setItem('bookingDate', date);
                            sessionStorage.setItem('bookingTime', time);


                            if (date && time && date != '' && date != '0' && time != '' && time != '0'){
                                $('#confirm-booking-calendar').addClass('active');
                                $('#date-time-holder').html('<span class="date d-block">Date: ' + moment(date, "YYYY-MM-DD").format("MM / DD / YYYY") + '</span> ' +  '<span class="time d-block">Time: ' + time + '</span>');
                            } else {
                                $('#confirm-booking-calendar').removeClass('active');
                            }
                        }, 100);

                    });

                    $(document).on('gform_confirmation_loaded', function(){
                        sessionStorage.removeItem('bookingDate');
                        sessionStorage.removeItem('bookingTime');
                    });


                    $(document).on('gform_post_render', function(event, formId){
                        if (sessionStorage.getItem('bookingDate') && sessionStorage.getItem('bookingTime')) {
                            $('#date-time-holder').html('<span class="date d-block">Date: ' + moment(sessionStorage.getItem('bookingDate'), "YYYY-MM-DD").format("MM / DD / YYYY") + '</span> ' +  '<span class="time d-block">Time: ' + sessionStorage.getItem('bookingTime') + '</span>');
                        }
                    });
                }
            }

            $('body').on('click', '#gappointments_calendar_slots label.time_slot', function() {
                if (isMobile || viewport().width < 990) {
                    setTimeout(function () {
                        $bookingField.removeClass('active');
                    }, 500);
                }
            });

            if ($bookingControls && $bookingControls.length > 0) {
                let $calendarTrigger = $bookingControls.find('#trigger-calendar'),
                    $dataWrapper = $bookingControls.find('#date-time-holder');

                //Opens calendar modal on click (added via shortcode)
                $calendarTrigger.on('click', function (e) {
                    e.preventDefault();
                    $bookingField.addClass('active');
                });

                //Adds custom controls to the calendar modal
                $bookingField.append('<div id="close-booking-calendar"><i class="fas fa-times"></i></div>');
                $calendar.append('<div class="btn btn-primary" id="confirm-booking-calendar">Confirm Selection</div>');

                //Adds control functionality to the newly added controls
                $('#close-booking-calendar, #confirm-booking-calendar').on('click', function () {
                    $bookingField.removeClass('active');
                });
            }


            const $form = $('#strategy-call-modal form');

            if ($form.length > 0) {
                const id = $form.attr('id');

                var idVal = id.split('_');

                idVal = parseInt(idVal[1]);


                $form.on('submit', function () {
                    $(this).addClass('loading-submit');
                });

                $(document).on('gform_confirmation_loaded', function(e, fid){
                    if(fid === idVal) {
                        $form.removeClass('loading-submit');
                    }
                });
            }

        });


        function ajaxHelper(data, action) {
            return new Promise(function (resolve, reject) {
                if ( ! data ) {
                    reject('didnt get data object');
                }
                $.ajax({
                    url: localize.ajaxurl,
                    data: {
                        'action' : action,
                        'data' : data
                    },
                    type: 'POST',
                    success: function( response ) {
                        if ( response ) {
                            resolve(response);
                        } else {
                            reject('Something Went Wrong');
                        }
                    }
                });
            });
        }


        $('.masonry').masonry({
            columnWidth: '.grid-sizer',
            itemSelector: '.type-review',
            gutter: 30
        });





        let mobileMenu = {
            open: false,
            items: {
                hamburger: $('#burger'),
                burgerWrapper: $('#burger-wrapper'),
                navbar: $('.m-wrapper-outer'),
                body: $('body')
            },
            functions: {
                toggle: function () {
                    this.items.hamburger.toggleClass('animate');
                    this.items.navbar.toggleClass('active');
                    this.items.body.toggleClass('prevent-scroll');
                    this.open = !this.open;
                },
                open: function () {
                    this.items.hamburger.addClass('animate');
                    this.items.navbar.addClass('active');
                    this.items.body.addClass('prevent-scroll');
                    this.open = true;
                },
                close: function () {
                    this.items.hamburger.removeClass('animate');
                    this.items.navbar.removeClass('active');
                    this.items.body.removeClass('prevent-scroll');
                    this.open = false;
                }
            }
        };

        mobileMenu.items.burgerWrapper.on('click', function () {
            mobileMenu.functions.toggle.call(mobileMenu);
        });


        /*
        ******************************************************************************************************
            Calculates the correct window height and width (including scrollbar)
        ******************************************************************************************************
        */
        function viewport() {
            var e = window, a = 'inner';
            if (!('innerWidth' in window )) {
                a = 'client';
                e = document.documentElement || document.body;
            }
            return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
        }



        /*
        ******************************************************************************************************
            Tables
        ******************************************************************************************************
        */

        $('#content table').each(function(){
            $(this).addClass('table');
        });

        (function () {
            let $table  = $('.table');
            if($table.length > 0){
                $table.each(function(i, table) {
                    $(table).wrap('<div class="table-responsive"></div>');
                });
            }
        })();


    });

})( jQuery );
